import { Typography, Flex } from "antd";
import { useTranslate } from "@refinedev/core";
import { InsightCard } from "./InsightCard";
import { NoInsights } from "./NoInsights";
import type { ExperienceInsight, InsightsGenerationStatus } from "../../types";

export type InsightCardListProps = {
  insights: ExperienceInsight[];
  status: InsightsGenerationStatus | null;
  isLoading: boolean;
  setSelectedInsight: (insight: ExperienceInsight) => void;
  onComplete: (id: string) => void;
  onPostpone: (id: string) => void;
  onDismiss: (id: string) => void;
};

export const InsightCardList = ({
  insights,
  status,
  isLoading,
  setSelectedInsight,
  onComplete,
  onPostpone,
  onDismiss,
}: InsightCardListProps) => {
  const t = useTranslate();

  if (isLoading || !status) return null;
  if (status === "Failed")
    return (
      <Flex vertical align="center" style={{ padding: 24 }}>
        <Typography.Text type="danger">
          {t("media.analytics.insights.failed")}
        </Typography.Text>
      </Flex>
    );
  if (insights.length === 0 && status === "Done") return <NoInsights />;

  return insights.map((insight) => (
    <InsightCard
      key={insight.id}
      insight={insight}
      onClick={setSelectedInsight}
      onComplete={onComplete}
      onPostpone={onPostpone}
      onDismiss={onDismiss}
    />
  ));
};
